import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Link, Text } from '@fiverr-private/typography';
import { ExternalLinkIcon } from '@fiverr-private/visuals';
import { DropdownMenu, MenuItem } from '@fiverr-private/dropdown';
import { BI_EVENTS, BI_OPTIONS, CHATGPT_URL, CLAUDE_URL, ChatGptIcon, ClaudeIcon } from '@fiverr-private/layout_menus';
import { AppI18n } from '../../../i18n';
import { reportConnectToAi } from './reportConnectToAi';

const reportOption = (option: (typeof BI_OPTIONS)[keyof typeof BI_OPTIONS]) =>
    reportConnectToAi({ type: BI_EVENTS.clickedOption, action: 'click', option });

interface BrandRowProps {
    href: string;
    option: (typeof BI_OPTIONS)[keyof typeof BI_OPTIONS];
    icon: React.ReactNode;
    children: React.ReactNode;
}

const BrandRow = ({ href, option, icon, children }: BrandRowProps) => (
    <Container paddingX="1">
        <DropdownMenu maxHeight="auto">
            <MenuItem href={href} target="_blank" rel="noopener" onClick={() => reportOption(option)}>
                <Stack width="100%" gap="2" alignItems="center" justifyContent="spaceBetween">
                    <Stack gap="2" alignItems="center">
                        {icon}
                        <Container color="grey_1100">
                            <Text size="b_md" fontWeight="semibold" color="inherit">
                                {children}
                            </Text>
                        </Container>
                    </Stack>
                    <ExternalLinkIcon size="sm" color="grey_900" />
                </Stack>
            </MenuItem>
        </DropdownMenu>
    </Container>
);

export const ConnectToAiContent = () => (
    <Stack direction="column" gap="3">
        <Container paddingX="4" paddingTop="2">
            <Container color="black">
                <Text size="b_sm" color="inherit">
                    <AppI18n k="connect_to_ai.description" />
                </Text>
            </Container>
        </Container>
        <BrandRow href={CHATGPT_URL} option={BI_OPTIONS.chatgpt} icon={<ChatGptIcon />}>
            <AppI18n k="connect_to_ai.chatgpt" />
        </BrandRow>
        <BrandRow href={CLAUDE_URL} option={BI_OPTIONS.claude} icon={<ClaudeIcon />}>
            <AppI18n k="connect_to_ai.claude" />
        </BrandRow>
        <Container paddingX="4" paddingTop="2" paddingBottom="2" color="grey_1100">
            <Link
                href={pathfinder('mcp_page')}
                target="_blank"
                rel="noopener"
                size="b_xs"
                color="inherit"
                onClick={() => reportOption(BI_OPTIONS.learnMore)}
            >
                <AppI18n k="connect_to_ai.learn_more" />
            </Link>
        </Container>
    </Stack>
);
